<template>
  <div class="pharmacy-cashier-page">
    <!-- Header Card -->
        <PageHeader icon="fas fa-cash-register">
      <template #title>
        Kasir Apotek
      </template>
      <template #subtitle>
        Pilih obat, lengkapi data pasien, lalu proses pembayaran transaksi apotek
      </template>
    </PageHeader>

    <b-alert :show="!cashierShift" variant="warning" class="mx-2" dismissible>
      <div class="d-flex flex-wrap align-items-center justify-content-between">
        <span><i class="fas fa-lock mr-2"></i>Buka shift kasir sebelum memproses penjualan apotek.</span>
        <b-button size="sm" variant="warning" @click="openCashierShift">Buka Shift</b-button>
      </div>
    </b-alert>
    <b-alert :show="!!cashierShift" variant="success" class="mx-2 py-2">
      <i class="fas fa-user-clock mr-2"></i>Shift aktif #{{ cashierShift && cashierShift.id }} · kas awal {{ formatCurrency(cashierShift && cashierShift.opening_cash) }}
    </b-alert>
    <div class="mx-2 mb-2">
      <div class="card mb-2"><div class="card-body py-3 d-flex flex-wrap align-items-center justify-content-between">
        <div><b>Mode Fulfillment</b><small class="d-block text-muted">Express untuk retail cepat · Standard untuk resep/order kompleks dengan picking dan verifikasi terpisah.</small></div>
        <b-button-group><b-button :variant="fulfillmentMode==='express'?'primary':'outline-primary'" @click="setFulfillmentMode('express')"><i class="fas fa-bolt mr-1"></i>Express</b-button><b-button :variant="fulfillmentMode==='standard'?'primary':'outline-primary'" @click="setFulfillmentMode('standard')"><i class="fas fa-clipboard-list mr-1"></i>Standard</b-button></b-button-group>
      </div></div>
      <div class="row no-gutters mx-n1">
        <div class="col-md-4 px-1"><b-form-select v-model="form.warehouse_id" :options="warehouseOptions" /></div>
        <div class="col-md-4 px-1"><b-form-input v-model="safetyContext.allergies" placeholder="Alergi pasien (pisahkan koma)" /></div>
        <div class="col-md-4 px-1"><b-form-input v-model="safetyContext.conditions" placeholder="Kondisi/diagnosis (pisahkan koma)" /></div>
      </div>
      <small v-if="!form.warehouse_id" class="text-danger ml-2">Gudang/depot wajib dipilih agar FEFO akurat.</small>
    </div>

    <div v-if="readyFulfillments.length" class="mx-2 mb-2"><div class="card border-primary"><div class="card-body py-3"><div class="d-flex justify-content-between"><div><b>Picking Terverifikasi — Siap Dibayar</b><small class="d-block text-muted">Klik work order untuk memuat hasil picking ke keranjang.</small></div><b-badge variant="primary">{{ readyFulfillments.length }} siap</b-badge></div><div class="d-flex flex-wrap mt-2" style="gap:8px"><b-button v-for="row in readyFulfillments" :key="row.id" variant="outline-primary" class="text-left" @click="loadFulfillmentToCart(row)"><b>{{ row.number }}</b><small class="d-block">{{ row.patient_name||'Tanpa pasien' }} · {{ row.status==='partially_verified'?'Partial':'Lengkap' }}</small></b-button></div></div></div></div>

    <div class="row no-gutters mx-n1 pharmacy-cashier-toolbar">
      <div class="col-xl-8 col-md-7 col-12 px-2 py-lg-0 py-1">
        <div class="card pharmacy-cashier-toolbar__catalog">
          <div class="row p-2 align-items-center">
            <!-- Filter Category -->
            <div class="col-md-8">
              <b-nav pills class="nav-category custom-scroller">
                <b-nav-item
                  :active="navActive == null"
                  @click="navCategoryAllOnClick"
                >
                  Semua
                </b-nav-item>
                <b-nav-item
                  v-for="(category, index) in medicineCategories"
                  :key="category.id"
                  :active="navActive == index"
                  @click="navCategoryOnClick(index, category.id)"
                >
                  {{ category.name }}
                </b-nav-item>
              </b-nav>
            </div>

            <!-- Search By Name -->
            <div class="col-md-4 pharmacy-cashier-search">
              <modern-search-input
                v-model="filter.search"
                fluid
                placeholder="Cari obat"
                @keyup="inputSearchOnKeyUp"
              />
            </div>
          </div>
        </div>
      </div>

      <div class="col-xl-4 col-md-5 col-12 px-2 py-lg-0 py-1 pharmacy-cashier-toolbar__people">
        <div class="row no-gutters mx-n1">
          <div class="col-md py-lg-0 py-1 px-1 pharmacy-cashier-person-wrap">
            <b-button
              squared
              class="btn btn-lg btn-block btn-info modal-trigger text-center pharmacy-cashier-person"
              v-b-modal.modal-patient
            >
              <i class="fas fa-user-injured mr-2"></i>{{ display.patient_name }}
            </b-button>
          </div>
          <div class="col-md py-lg-0 py-1 px-1 pharmacy-cashier-person-wrap">
            <b-button
              squared
              class="btn btn-lg btn-block btn-info modal-trigger text-center pharmacy-cashier-person"
              v-b-modal.modal-doctor
            >
              <i class="fas fa-user-md mr-2"></i>{{ display.doctor_name }}
            </b-button>
          </div>
        </div>
      </div>
    </div>

    <div v-if="releasedCompounds.length" class="mx-2 mb-2">
      <div class="card"><div class="card-body py-3">
        <div class="d-flex justify-content-between align-items-center mb-2"><div><b>Racikan Siap Dijual</b><small class="d-block text-muted">Sudah selesai QC dan stok bahan telah dikonsumsi per batch.</small></div><b-badge variant="success">{{ releasedCompounds.length }} siap</b-badge></div>
        <div class="d-flex flex-wrap" style="gap:8px"><b-button v-for="item in releasedCompounds" :key="item.id" variant="outline-success" class="text-left" @click="addCompoundToCart(item)"><i class="fas fa-mortar-pestle mr-2"></i><b>{{ item.formula_name }}</b><small class="d-block">{{ item.number }} · {{ item.output_quantity }} {{ item.output_uom }} · {{ formatCurrency(item.total_amount) }}</small></b-button></div>
      </div></div>
    </div>

    <div class="row no-gutters mx-n1 pharmacy-cashier-content">
      <div
        class="col-xl-8 col-md-7 col-12 px-2 pharmacy-cashier-catalog"
        ref="medicineScroller"
        @scroll="medicineOnScroll"
      >
        <div
          v-if="isLoadingMedicines && medicines.length === 0"
          class="pharmacy-cashier-catalog__state"
        >
          <b-spinner small variant="info" />
          <span>Memuat katalog obat…</span>
        </div>
        <div
          v-else-if="medicines.length === 0"
          class="pharmacy-cashier-catalog__state"
        >
          <i class="fas fa-search"></i>
          <strong>Obat tidak ditemukan</strong>
          <span>Coba kata kunci atau kategori lain.</span>
        </div>
        <div class="row no-gutters mx-n1 pharmacy-cashier-catalog__grid">
          <div
            class="col-xl-3 col-lg-4 col-md-6 col-sm-6 col-12 p-2"
            v-for="medicine in medicines"
            :key="medicine.id"
          >
            <MedicineCard :data="medicine" @cardOnClick="cardMedicineOnClick" />
          </div>
        </div>
        <div v-if="isLoadingMore" class="pharmacy-cashier-catalog__more">
          <b-spinner small variant="info" /> Memuat obat lainnya…
        </div>
      </div>

      <div class="col-xl-4 col-md-5 col-12 px-2 pharmacy-cashier-order">
        <div class="row no-gutters my-1 mx-n1">
          <div class="col-md px-1">
            <b-button
              class="btn btn-lg btn-block btn-info modal-trigger pharmacy-cashier-prescription"
              squared
              @click="$bvModal.show('modal-prescription')"
            >
              <i class="fas fa-file-prescription mr-2"></i>Pilih resep
            </b-button>
          </div>
        </div>
        <div class="row no-gutters my-1 mx-n1">
          <div class="col-md">
            <div class="card shadow-sm pharmacy-cashier-cart" style="min-height: calc(100vh - 415px)">
              <div class="pharmacy-cashier-cart__header">
                <div><span>TRANSAKSI AKTIF</span><strong>Keranjang penjualan</strong></div>
                <b-badge pill>{{ cartItemCount }} item</b-badge>
              </div>
              <div
                class="card-body py-2 px-3"
                style="height: 100%; overflow-y: auto"
              >
                <div
                  v-if="form.items.length === 0 && form.itemsUnavailable.length === 0"
                  class="pharmacy-cashier-cart__empty"
                >
                  <i class="fas fa-shopping-basket"></i>
                  <strong>Belum ada obat</strong>
                  <span>Pilih obat dari katalog untuk memulai transaksi.</span>
                </div>

                <!-- items unavailable stock -->
                <div
                  class="list-group list-group-flush"
                  style="overflow: hidden"
                >
                  <div
                    class="row py-1 pharmacy-cashier-cart__item pharmacy-cashier-cart__item--warning"
                    v-for="(item, index) in form.itemsUnavailable"
                    :key="item.item_type==='compound'?'compound-'+item.compound_work_order_id:'medicine-'+item.medicine_id"
                  >
                    <div
                      class="col-md-12 d-flex justify-content-between align-items-center pb-0"
                    >
                      <div
                        class="text-truncate"
                        style="font-size: 13px; width: 100px"
                      >
                        {{ item.medicine_name }}
                      </div>
                      <b-button
                        size="sm"
                        variant="outline-danger"
                        aria-label="Hapus item stok tidak tersedia"
                        @click="removeUnavailableItem(index)"
                      ><i class="fas fa-times"></i></b-button>
                      <div class="text-right">
                        <div class="font-weight-bold">
                          {{
                            parseInt(
                              parseInt(item.amount) * parseInt(item.quantity)
                            ).toLocaleString("id-ID")
                          }}
                        </div>
                        <div v-if="item.promo_amount > 0">
                          <small>
                            -
                            {{
                              parseInt(
                                parseInt(item.promo_amount) *
                                  parseInt(item.quantity)
                              ).toLocaleString("id-ID")
                            }}
                          </small>
                        </div>
                      </div>
                    </div>
                    <div class="col-md-12 pt-1 pb-2">
                      <small class="text-danger">Stok tersedia {{ formatNumber(item.stock) }}, kebutuhan {{ formatNumber(item.quantity) }}</small>
                    </div>
                  </div>
                </div>

                <!-- items available stock -->
                <div class="list-group list-group-flush">
                  <div
                    class="d-flex justify-content-between align-items-center py-2 pharmacy-cashier-cart__item"
                    v-for="(item, index) in form.items"
                    :key="item.medicine_id"
                  >
                    <div class="pharmacy-cashier-cart__product">
                      <strong class="text-truncate">{{ item.medicine_name }}</strong>
                      <span v-if="item.promo" class="pharmacy-promo-badge">
                        <i class="fas fa-tag"></i> {{ item.promo.name }}
                      </span>
                      <small v-if="item.promo_amount > 0">
                        <s>{{ formatCurrency(item.amount) }}</s>
                        → {{ formatCurrency(item.amount - item.promo_amount) }} / unit
                      </small>
                      <small v-else>{{ formatCurrency(item.amount) }} / unit</small>
                      <small
                        v-if="!item.promo && item.candidate_promo"
                        class="pharmacy-promo-hint"
                      >
                        {{ item.candidate_promo.name }} · {{ item.promotion_reason }}
                      </small>
                    </div>
                    <div v-if="item.item_type!=='compound'" class="btn-group btn-group-sm">
                      <b-button
                        squared
                        class="btn btn-sm btn-info square"
                        @click="btnMinQtyOnClick(item, index)"
                        ><i class="fas fa-sm fa-fw fa-minus"></i
                      ></b-button>
                      <span>
                        <button
                          class="btn btn-sm btn-block bg-white btn-quantity"
                          @click="btnQtyOnClick(item, index)"
                        >
                          {{ item.quantity }}
                        </button>
                      </span>
                      <b-button
                        squared
                        class="btn btn-sm btn-info"
                        @click="btnAddQtyOnClick(item, index)"
                        ><i class="fas fa-sm fa-fw fa-plus"></i>
                      </b-button>
                    </div>
                    <b-button v-else size="sm" variant="outline-danger" @click="removeCartItem(index)"><i class="fas fa-trash"></i></b-button>
                    <div class="text-right">
                      <div class="font-weight-bold">
                        {{
                          parseInt(
                            parseInt(item.amount) * parseInt(item.quantity)
                          ).toLocaleString("id-ID")
                        }}
                      </div>
                      <div v-if="item.promo_amount > 0">
                        <small class="text-success">
                          Promo -
                          {{
                            parseInt(
                              parseInt(item.promo_amount) *
                                parseInt(item.quantity)
                            ).toLocaleString("id-ID")
                          }}
                        </small>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="card-footer py-2 px-3 bg-white pharmacy-cashier-cart__summary">
                <div class="d-flex justify-content-between">
                  <div>Subtotal</div>
                  <div class="font-weight-bold">
                    {{ formatCurrency(form.total_amount) }}
                  </div>
                </div>
                <div class="d-flex justify-content-between">
                  <div>Potongan Promo</div>
                  <div class="font-weight-bold">
                    {{
                      formatCurrency(form.total_promo_amount)
                    }}
                  </div>
                </div>
                <div class="d-flex justify-content-between">
                  <div>Total</div>
                  <div class="font-weight-bold h5 mb-0">
                    {{
                      formatCurrency(form.final_amount)
                    }}
                  </div>
                </div>
                <div class="d-flex">
                  <small class="text-danger" v-if="form.itemsUnavailable.length > 0">
                    {{ form.itemsUnavailable.length }} item resep tidak ikut dibayar karena stok tidak cukup.
                  </small>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="row no-gutters mx-n1 mt-3 pharmacy-cashier-actions">
      <div class="col-md px-2 offset-8 pharmacy-cashier-actions__inner">
        <div class="row no-gutters mx-n1">
          <div class="col-md-10 px-1">
            <button
              class="btn btn-lg btn-block btn-success"
              :disabled="!canCheckout || isSubmitting"
              @click="btnCheckoutOnClick"
            >
              <b-spinner v-if="isSubmitting" small class="mr-2" />
              <i v-else class="fas fa-fw fa-cash-register"></i>
              {{ isSubmitting ? "Memproses…" : (fulfillmentMode==='standard'&&!form.pharmacy_fulfillment_order_id?'Buat Work Order Picking':`Bayar ${formatCurrency(form.final_amount)}`) }}
            </button>
          </div>
          <div class="col-md-2 px-1">
            <button
              class="btn btn-lg btn-block btn-outline-danger"
              aria-label="Reset transaksi"
              title="Reset transaksi"
              :disabled="isSubmitting || (form.items.length === 0 && form.itemsUnavailable.length === 0)"
              @click="btnResetOnClick"
            >
              <i class="fas fa-fw fa-sync-alt"></i>
            </button>
          </div>
        </div>
      </div>
    </div>

    <b-modal id="modal-quantity" title="Jumlah Obat" ok-title="Terapkan" cancel-title="Batal" @ok.prevent="handleQtyModal">
      <b-form-group id="input-group-1" label="Jumlah Obat:" label-for="input-1">
        <b-form-input
          id="input-1"
          v-model="modalQuantity.quantity"
          type="number"
          min="1"
          :max="modalQuantity.stock"
          step="1"
          inputmode="numeric"
          autofocus
          @keyup.enter="handleQtyModal"
          placeholder="Masukkan Jumlah Obat"
        ></b-form-input>
      </b-form-group>
    </b-modal>

    <b-modal id="modal-fefo-preview" title="Konfirmasi Picking Express FEFO" size="lg" ok-title="Lanjut Pembayaran" cancel-title="Kembali" @ok.prevent="continueExpressPayment">
      <b-alert show variant="info">Periksa batch dan ED. Stok baru dikurangi setelah pembayaran berhasil.</b-alert>
      <div v-for="item in fefoPreview" :key="item.medicine_id" class="mb-3"><b>{{ item.medicine_name }}</b><small class="d-block text-muted">Kebutuhan {{ item.planned_quantity }} {{ item.uom_name }}<span v-if="item.shortage_quantity" class="text-danger"> · Kurang {{ item.shortage_quantity }}</span></small><table class="table table-sm mt-1"><thead><tr><th>Lokasi</th><th>Batch</th><th>ED</th><th>Ambil</th></tr></thead><tbody><tr v-for="batch in item.batches" :key="batch.medicine_batch_stock_id"><td>{{ batch.storage_location }}</td><td>{{ batch.batch_no||'-' }}</td><td>{{ batch.expired||'-' }}</td><td>{{ batch.reserved_quantity }}</td></tr></tbody></table></div>
      <b-form-checkbox v-model="form.express_verification_confirmed" class="font-weight-bold">Saya sudah mencocokkan obat, jumlah, batch, ED, kondisi kemasan, dan pasien.</b-form-checkbox>
      <b-form-input v-model="form.express_verification_notes" class="mt-2" placeholder="Catatan verifikasi Express (opsional)"/>
    </b-modal>

    <ModalCheckout
      :form="form"
      :coupon="coupon"
      :error="error"
      :is-submitting="isSubmitting"
      :isHospitalTransaction="false"
      @paymentMethodOnClick="paymentMethodOnClick"
      @btnShortCutOnClick="btnShortCutOnClick"
      @inputCashOnKeyUp="inputCashOnKeyUp"
      @btnEWalletOnClick="btnEWalletOnClick"
      @couponOnDismissed="couponOnDismissed"
      @modalCheckoutOnHide="modalCheckoutOnHide"
      @confirmCheckout="confirmCheckout"
    />

    <ModalPatient
      :isCashier="true"
      @chosenPatient="setPatient"
      @submitedPatient="setPatient"
      @customSubmitedPatient="customSubmitedPatient"
    />

    <ModalDoctor
      @chosenDoctor="setDoctor"
      @submitedDoctor="setDoctor"
      @customSubmitedDoctor="customSubmitedDoctor"
    />

    <ModalPrescription :source="1" @setSelectedItem="setSelectedItem" />

    <!-- Modal Coupon -->
    <ModalCoupon @chosenCoupon="modalCouponOnSelect" />
  </div>
</template>

<script>
// components
import ModalCoupon from "@/component/general/ModalCoupon.vue";
import MedicineCard from "@/component/pharmacy/cashier/MedicineCard.vue";
import ModalPatient from "@/component/general/ModalPatient.vue";
import ModalPrescription from "@/component/general/ModalPrescription.vue";
import ModalCheckout from "@/component/general/ModalCheckout.vue";
import ModalDoctor from "@/component/general/ModalDoctor.vue";

// modules
import axios from "axios";
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";
import { getPromoAmount } from "@/core/modules/Helper.js";
import module from "@/core/modules/CrudModule.js";
import validation from "@/core/modules/ValidationModule.js";
import ApiService from "@/core/services/api.service.js";
import { debouncer } from "@/core/modules/Helper.js";
import Swal from "sweetalert2";

const createInitialForm = () => ({
  doctor_id: "",
  doctor_name: "",
  patient_id: "",
  patient_name: "",
  prescription_id: null,
  fulfillment_mode: "express",
  pharmacy_fulfillment_order_id: null,
  payment_method_id: 1,
  bank_id: "",
  coupon_id: null,
  coupon_name: "",
  coupon_is_percent: 0,
  coupon_percentage_amount: 0,
  coupon_amount: 0,
  card_number: "",
  card_type: "",
  edc_struct: "",
  e_wallet_id: "",
  surcharge: 0,
  total_amount: 0,
  total_promo_amount: 0,
  tax_amount: 0,
  final_amount: 0,
  payment_amount: 0,
  change_amount: 0,
  notes: "",
  items: [],
  itemsUnavailable: [],
  cashier_shift_id: null,
  warehouse_id: null,
  idempotency_key: "",
  allocations: [],
  allergies: [],
  conditions: [],
  safety_override_reason: "",
  express_verification_confirmed: false,
  express_verification_notes: "",
});

export default {
  components: {
    ModalCoupon,
    MedicineCard,
    ModalPatient,
    ModalCheckout,
    ModalDoctor,
    ModalPrescription,
  },

  data() {
    return {
      // Display Data
      display: {
        patient_name: "Pilih Pasien",
        doctor_name: "Pilih Dokter",
      },
      // Medicines
      medicines: [],
      releasedCompounds: [],
      readyFulfillments: [],
      fulfillmentMode: "express",
      fefoPreview: [],
      medicineCategories: [],
      // coupon
      coupon: null,
      // Form
      form: createInitialForm(),
      error: {
        bank_id: "",
        card_number: "",
        card_type: "",
        edc_struct: "",
      },
      // Filter
      filter: {
        medicine_category_id: "",
        search: "",
      },
      // modal quantity
      modalQuantity: {
        index: "",
        item: [],
        quantity: 0,
        old_subtotal: 0,
      },
      // Pagination
      perPage: 20,
      currentPage: 1,
      totalRow: 0,
      // Print Data
      items: [],
      data: {},
      // Others
      navActive: null,
      prescriptData: [],
      prescriptId: "",
      dataDisplay: false,
      isLoadingMedicines: false,
      isLoadingMore: false,
      isSubmitting: false,
      medicineRequestId: 0,
      promotionRefreshTimer: null,
      promotionPreviewLoading: false,
      cashierShift: null,
      warehouses: [],
      safetyContext: { allergies: "", conditions: "" },
    };
  },

  computed: {
    warehouseOptions() {
      return [{ value: null, text: "Pilih gudang/depot", disabled: true }].concat(
        this.warehouses.map(row => ({ value: row.id, text: row.name }))
      );
    },
    cartItemCount() {
      return this.form.items.reduce(
        (total, item) => total + Number(item.quantity || 0),
        0
      );
    },
    canCheckout() {
      const hasOrder=this.form.items.length>0&&!!this.form.warehouse_id;
      if(this.fulfillmentMode==="standard"&&!this.form.pharmacy_fulfillment_order_id)return hasOrder;
      return hasOrder&&this.form.final_amount>=0&&!!this.cashierShift;
    },
  },

  methods: {
    async requestPromotionPreview(items) {
      if (!items.length) return [];
      const response = await ApiService.post(
        "marketing-governance/promotion-preview",
        {
          items,
          patient_id: this.form.patient_id || null,
          payment_method_id: this.form.payment_method_id || null,
          service_channel: "pharmacy",
        }
      );
      return (response.data && response.data.data) || [];
    },

    async previewMedicineRows(rows) {
      if (!rows.length) return rows;
      const previews = await this.requestPromotionPreview(
        rows.map((row) => ({ type: "medicine", id: row.id }))
      );
      const previewMap = previews.reduce((map, preview) => {
        map[preview.id] = preview;
        return map;
      }, {});
      return rows.map((row) => {
        const preview = previewMap[row.id];
        if (!preview) return row;
        return {
          ...row,
          promo: preview.promo,
          promo_id: preview.promo ? preview.promo.id : null,
          promo_amount: Number(preview.promo_amount) || 0,
          promotion_status: preview.status,
          promotion_reason: preview.reason,
          candidate_promo: preview.candidate_promo || null,
          promotion_original_price: preview.original_price,
          promotion_final_price: preview.final_price,
        };
      });
    },

    schedulePromotionRefresh() {
      window.clearTimeout(this.promotionRefreshTimer);
      this.promotionRefreshTimer = window.setTimeout(
        () => this.refreshPharmacyPromotions(),
        250
      );
    },

    async refreshPharmacyPromotions() {
      if (this.promotionPreviewLoading) return;
      const cartItems = this.form.items.filter(
        (item) => item.item_type !== "compound" && item.medicine_id
      );
      if (!cartItems.length && !this.medicines.length) return;
      this.promotionPreviewLoading = true;
      try {
        const [catalog, cartPreviews] = await Promise.all([
          this.previewMedicineRows(this.medicines),
          this.requestPromotionPreview(
            cartItems.map((item) => ({
              type: "medicine",
              id: item.medicine_id,
            }))
          ),
        ]);
        this.medicines = catalog;
        const previewMap = cartPreviews.reduce((map, preview) => {
          map[preview.id] = preview;
          return map;
        }, {});
        cartItems.forEach((item) => {
          const preview = previewMap[item.medicine_id];
          if (!preview) return;
          this.$set(item, "promo", preview.promo);
          this.$set(item, "promo_id", preview.promo ? preview.promo.id : null);
          this.$set(item, "promo_amount", Number(preview.promo_amount) || 0);
          this.$set(item, "promotion_status", preview.status);
          this.$set(item, "promotion_reason", preview.reason);
          this.$set(item, "candidate_promo", preview.candidate_promo || null);
        });
        this.recalculateTotals();
      } catch (error) {
        cartItems.forEach((item) =>
          this.$set(
            item,
            "promotion_reason",
            "Preview promo belum dapat dimuat; harga akan divalidasi saat transaksi disimpan."
          )
        );
      } finally {
        this.promotionPreviewLoading = false;
      }
    },

    setFulfillmentMode(mode) {
      if (this.form.pharmacy_fulfillment_order_id && mode !== "standard") { Swal.fire("Work order aktif","Selesaikan atau reset transaksi Standard yang sedang dimuat.","info"); return; }
      this.fulfillmentMode=mode;this.form.fulfillment_mode=mode;
    },
    async loadReadyFulfillments() {
      try { const response=await ApiService.get("pharmacy-fulfillments","?page_size=100");const value=response.data&&response.data.data;const rows=value&&Array.isArray(value.data)?value.data:(Array.isArray(value)?value:[]);this.readyFulfillments=rows.filter(row=>["verified","partially_verified"].includes(row.status)); } catch(e){this.readyFulfillments=[];}
    },
    async loadFulfillmentToCart(row) {
      try { const response=await ApiService.get(`pharmacy-fulfillments/${row.id}`);const data=response.data.data;this.resetForm();this.fulfillmentMode="standard";this.form.fulfillment_mode="standard";this.form.pharmacy_fulfillment_order_id=data.id;this.form.warehouse_id=data.warehouse_id;this.form.prescription_id=data.prescription_id;this.form.patient_id=data.patient_id||"";this.form.patient_name=data.patient_name||"";this.form.doctor_id=data.doctor_id||"";this.form.doctor_name=data.doctor_name||"";this.display.patient_name=data.patient_name||"Pilih Pasien";this.display.doctor_name=data.doctor_name||"Pilih Dokter";this.form.items=data.items.filter(item=>Number(item.picked_quantity)>0).map(item=>({item_type:"medicine",medicine_id:item.medicine_id,medicine_name:item.medicine_name,quantity:Number(item.requested_quantity),dispensed_quantity:Number(item.picked_quantity),amount:Number(item.sales_price),promo_amount:0,subtotal:Number(item.sales_price)*Number(item.picked_quantity),stock:Number(item.requested_quantity),signa:item.signa,usage_instruction:item.usage_instruction,shortage_reason:item.shortage_reason}));await this.refreshPharmacyPromotions();this.recalculateTotals();Swal.fire("Work order dimuat","Hasil picking terverifikasi siap dibayar.","success"); } catch(e){Swal.fire("Tidak dapat dimuat",e.response?.data?.message||"Work order tidak tersedia.","error");}
    },
    async createStandardFulfillment() {
      if(this.form.items.some(item=>item.item_type==="compound")){Swal.fire("Gunakan alur racikan","Racikan memiliki work order produksi sendiri dan tidak digabung ke picking obat biasa.","warning");return;}
      try { const payload={warehouse_id:this.form.warehouse_id,prescription_id:this.form.prescription_id||null,patient_id:this.form.patient_id||null,patient_name:this.form.patient_name||null,doctor_id:this.form.doctor_id||null,doctor_name:this.form.doctor_name||null,priority:this.form.prescription_id?"urgent":"normal",notes:"Dibuat dari Kasir Apotek mode Standard",items:this.form.items.map(item=>({medicine_id:item.medicine_id,quantity:Number(item.quantity),signa:item.signa||null,usage_instruction:item.usage_instruction||null}))};const response=await ApiService.post("pharmacy-fulfillments",payload);const number=response.data.data.number;this.resetForm();this.fulfillmentMode="standard";this.form.fulfillment_mode="standard";await this.loadReadyFulfillments();Swal.fire("Work order dibuat",`${number} masuk antrean Operasional Apotek. Pembayaran dilakukan setelah picking dan verifikasi apoteker.`,"success"); } catch(e){Swal.fire("Work order gagal",Object.values(e.response?.data?.errors||{}).flat().join(" ")||e.response?.data?.message||"Periksa stok dan data order.","error");}
    },
    async previewExpress() {
      const medicines=this.form.items.filter(item=>item.item_type!=="compound");if(!medicines.length){this.$bvModal.show("modal-checkout");return;}
      try { const response=await ApiService.post("pharmacy-fulfillments/preview",{warehouse_id:this.form.warehouse_id,items:medicines.map(item=>({medicine_id:item.medicine_id,quantity:Number(item.quantity),dispensed_quantity:Number(item.dispensed_quantity||item.quantity)}))});this.fefoPreview=response.data.data;if(this.fefoPreview.some(item=>Number(item.shortage_quantity)>0)){Swal.fire("Stok FEFO kurang","Kurangi jumlah atau gunakan mode Standard untuk partial fulfillment.","warning");return;}this.$bvModal.show("modal-fefo-preview"); } catch(e){Swal.fire("Preview FEFO gagal",Object.values(e.response?.data?.errors||{}).flat().join(" ")||"Periksa gudang dan stok batch.","error");}
    },
    continueExpressPayment(){if(!this.form.express_verification_confirmed){Swal.fire("Verifikasi belum lengkap","Centang konfirmasi setelah obat, batch, ED, dan pasien dicocokkan.","warning");return;}this.$bvModal.hide("modal-fefo-preview");this.$bvModal.show("modal-checkout");},
    async loadCashierShift() {
      try {
        const response = await ApiService.get("pharmacy-sales/shift");
        this.cashierShift = response.data.data || null;
        this.form.cashier_shift_id = this.cashierShift ? this.cashierShift.id : null;
      } catch (error) {
        this.cashierShift = null;
      }
    },

    async loadWarehouses() {
      try {
        const response = await ApiService.get("warehouses", "?page_size=500");
        this.warehouses = response.data.data || [];
        if (!this.form.warehouse_id && this.warehouses.length === 1) this.form.warehouse_id = this.warehouses[0].id;
      } catch (error) { this.warehouses = []; }
    },

    async loadReleasedCompounds() {
      try {
        const response = await ApiService.get("pharmacy-compound-work-orders/released");
        const payload = response.data && response.data.data;
        this.releasedCompounds = Array.isArray(payload) ? payload : (payload && Array.isArray(payload.data) ? payload.data : []);
        if (!this.releasedCompounds.length) {
          const fallback = await ApiService.get("pharmacy-compound-work-orders", "?page_size=100&status=released");
          const value = fallback.data && fallback.data.data;
          this.releasedCompounds = Array.isArray(value) ? value : (value && Array.isArray(value.data) ? value.data : []);
        }
      }
      catch (error) { this.releasedCompounds = []; }
    },

    addCompoundToCart(item) {
      if (this.form.items.some(row => row.compound_work_order_id === item.id)) { Swal.fire("Sudah dipilih", "Work order racikan ini sudah ada di keranjang.", "info"); return; }
      if (this.form.warehouse_id && Number(this.form.warehouse_id) !== Number(item.warehouse_id)) { Swal.fire("Gudang berbeda", "Pilih gudang yang sama dengan work order racikan.", "warning"); return; }
      this.form.warehouse_id = item.warehouse_id;
      this.form.items.push({item_type:"compound",compound_work_order_id:item.id,compound_id:item.pharmacy_compound_id,medicine_id:null,medicine_name:item.formula_name,quantity:1,dispensed_quantity:1,amount:Number(item.total_amount),promo_id:null,promo_amount:0,subtotal:Number(item.total_amount),stock:1,signa:item.signa,usage_instruction:item.usage_instruction,uom_name:item.output_uom,notes:item.number});
      if (item.patient_id && !this.form.patient_id) { this.form.patient_id=item.patient_id;this.form.patient_name=item.patient_name;this.display.patient_name=item.patient_name||"Pasien"; }
      if (item.doctor_id && !this.form.doctor_id) { this.form.doctor_id=item.doctor_id;this.form.doctor_name=item.doctor_name;this.display.doctor_name=item.doctor_name||"Dokter"; }
      this.recalculateTotals();
    },

    removeCartItem(index) { this.form.items.splice(index,1); this.recalculateTotals(); },

    async openCashierShift() {
      const result = await Swal.fire({
        title: "Buka Shift Kasir",
        input: "number",
        inputLabel: "Kas awal",
        inputValue: 0,
        showCancelButton: true,
        confirmButtonText: "Buka Shift",
        inputValidator: value => Number(value) < 0 ? "Kas awal tidak boleh negatif" : null,
      });
      if (!result.value && result.value !== "0") return;
      try {
        await ApiService.post("billing/shifts/open", { opening_cash: Number(result.value) });
        await this.loadCashierShift();
        Swal.fire("Shift aktif", "Kasir apotek siap digunakan.", "success");
      } catch (error) {
        Swal.fire("Shift gagal dibuka", (error.response && error.response.data && error.response.data.message) || "Periksa kembali data shift.", "error");
      }
    },

    navCategoryAllOnClick() {
      this.navActive = null;
      this.filter.medicine_category_id = "";
      this.currentPage = 1;
      this.scrollMedicineToTop();
      this.getMedicine();
    },

    modalCouponOnSelect(value) {
      const amountBeforeCoupon = this.getAmountBeforeCoupon();
      const newCouponAmount = this.calculateCouponAmount(value, amountBeforeCoupon);
      // validate coupon amount
      if (
        amountBeforeCoupon <= 0 ||
        amountBeforeCoupon < newCouponAmount
      ) {
        Swal.fire(
          "Pemberitahuan",
          "Kupon tidak boleh melebihi nominal transaksi",
          "warning"
        );
        return;
      }
      this.$bvModal.hide("modal-coupon");
      this.coupon = value;
      this.form.coupon_id = value.id;
      this.form.coupon_name = value.name;
      this.form.coupon_is_percent = value.is_percent;
      let couponPercentageAmount = 0;
      if (value.is_percent == 1) couponPercentageAmount = value.amount;
      this.form.coupon_percentage_amount = couponPercentageAmount;
      this.form.coupon_amount = newCouponAmount;
      this.recalculateTotals();
    },

    couponOnDismissed() {
      this.coupon = null;
      // reset coupon
      this.form.coupon_id = null;
      this.form.coupon_name = "";
      this.form.coupon_is_percent = 0;
      this.form.coupon_percentage_amount = 0;
      this.form.coupon_amount = 0;
      this.recalculateTotals();
    },

    getAmountBeforeCoupon() {
      return Math.max(
        0,
        Number(this.form.total_amount) - Number(this.form.total_promo_amount) +
          Number(this.form.tax_amount) + Number(this.form.surcharge)
      );
    },

    calculateCouponAmount(coupon, baseAmount) {
      if (!coupon || baseAmount <= 0) return 0;
      let amount = coupon.is_percent == 1
        ? Math.floor(baseAmount * (Number(coupon.amount) / 100))
        : Number(coupon.amount);
      if (Number(coupon.max_amount) > 0) {
        amount = Math.min(amount, Number(coupon.max_amount));
      }
      return Math.min(Math.max(0, amount), baseAmount);
    },

    recalculateTotals() {
      this.form.total_amount = this.form.items.reduce(
        (total, item) => total + Number(item.amount || 0) * Number(item.dispensed_quantity == null ? item.quantity : item.dispensed_quantity),
        0
      );
      this.form.total_promo_amount = this.form.items.reduce(
        (total, item) => total + Number(item.promo_amount || 0) * Number(item.dispensed_quantity == null ? item.quantity : item.dispensed_quantity),
        0
      );
      const amountBeforeCoupon = this.getAmountBeforeCoupon();
      this.form.coupon_amount = this.calculateCouponAmount(this.coupon, amountBeforeCoupon);
      this.form.final_amount = Math.max(0, amountBeforeCoupon - this.form.coupon_amount);
      if (this.form.payment_method_id !== 1) {
        this.form.payment_amount = this.form.final_amount;
        this.form.change_amount = 0;
      } else if (this.form.payment_amount) {
        this.inputCashOnKeyUp();
      }
    },

    formatCurrency(value) {
      return `Rp ${this.formatNumber(value)}`;
    },

    formatNumber(value) {
      return Number(value || 0).toLocaleString("id-ID");
    },

    // set data from prescription
    async setSelectedItem(data, id) {
      // hide modal
      this.$bvModal.hide("modal-prescription");
      // set data form
      this.form.items = [];
      this.fulfillmentMode = "standard";
      this.form.fulfillment_mode = "standard";
      this.form.itemsUnavailable = (data.unavailable || []).map((item) => ({
        ...item,
        promo_amount: getPromoAmount(item.promo, item.amount),
      }));
      this.form.prescription_id = id;
      this.form.doctor_id = data.doctor_id;
      this.form.doctor_name = data.doctor_name;
      this.form.patient_id = data.patient_id;
      this.form.patient_name = data.patient_name;
      (data.available || []).forEach((el) => {
        this.setMedicineItemData(el, getPromoAmount(el.promo, el.amount));
      });
      // display
      let dr = (data.doctor_name || "").split(" ");
      let patient = (data.patient_name || "").split(" ");
      this.display.patient_name = patient[0];
      this.display.doctor_name = "dr." + dr[0];
      await this.refreshPharmacyPromotions();
      // get data prescription
      this.getDataPrescription(id);
    },

    async getDataPrescription(id) {
      let prescript = await module.get(`prescriptions/${id}`);
      this.prescriptData = prescript;
      this.prescriptId = id;
    },

    setPatient(value) {
      this.form.patient_id = value.id;
      this.form.patient_name = value.name;
      let name = value.name.split(" ");
      this.display.patient_name = `${name[0]}`;
      this.$bvModal.hide("modal-patient");
      this.schedulePromotionRefresh();
    },

    customSubmitedPatient(value) {
      this.form.patient_id = "";
      this.form.patient_name = value;
      this.display.patient_name = `Pasien: ${value}`;
      this.$bvModal.hide("modal-patient");
      this.schedulePromotionRefresh();
    },

    setDoctor(value) {
      this.form.doctor_id = value.id;
      this.form.doctor_name = value.name;
      let name = value.name.split(" ");
      this.display.doctor_name = `dr. ${name[0]}`;
      this.$bvModal.hide("modal-doctor");
    },

    customSubmitedDoctor(value) {
      this.form.doctor_id = "";
      this.form.doctor_name = value;
      this.display.doctor_name = `Dokter: ${value}`;
      this.$bvModal.hide("modal-doctor");
    },

    resetForm() {
      this.form = createInitialForm();
      this.fulfillmentMode = "express";
      this.coupon = null;
      this.display.patient_name = "Pilih Pasien";
      this.display.doctor_name = "Pilih Dokter";
      this.data = {};
      this.items = [];
      this.error = validation.clearValidationError(this.error);
      this.prescriptData = [];
      this.prescriptId = "";
    },

    btnResetOnClick() {
      Swal.fire({
        title: "Konfirmasi",
        text: "Reset Order?",
        showCancelButton: true,
        icon: "question",
      }).then((result) => {
        if (result.value) {
          this.resetForm();
          window.data = [];
        }
      });
    },

    scrollMedicineToTop() {
      if (this.$refs.medicineScroller) {
        this.$refs.medicineScroller.scrollTo({ top: 0, behavior: "smooth" });
      }
    },

    async getMedicine(isScrolled = false) {
      if (isScrolled && (this.isLoadingMore || this.medicines.length >= this.totalRow)) return;
      const requestId = ++this.medicineRequestId;
      this.isLoadingMedicines = !isScrolled;
      this.isLoadingMore = isScrolled;
      try {
        const response = await axios.get("medicines/get-for-cashier", {
          params: {
            medicine_category_id: this.filter.medicine_category_id,
            search: this.filter.search.trim(),
            with_promo: true,
            paginate: true,
            page: this.currentPage,
            per_page: this.perPage,
          },
        });
        if (requestId !== this.medicineRequestId) return;
        const result = response.data;
        const previewedRows = await this.previewMedicineRows(result.data || []);
        this.totalRow = result.total_row;
        if (isScrolled) {
          const existingIds = new Set(this.medicines.map((item) => item.id));
          this.medicines = this.medicines.concat(
            previewedRows.filter((item) => !existingIds.has(item.id))
          );
        } else {
          this.medicines = previewedRows;
        }
      } catch (error) {
        if (!isScrolled) this.medicines = [];
        Swal.fire("Gagal memuat obat", "Periksa koneksi lalu coba lagi.", "error");
      } finally {
        if (requestId === this.medicineRequestId) {
          this.isLoadingMedicines = false;
          this.isLoadingMore = false;
        }
      }
    },

    async getMedicineCategories() {
      this.medicineCategories = await module.list("medicine-categories");
    },

    navCategoryOnClick(index, id) {
      this.navActive = index;
      this.filter.medicine_category_id = id;
      this.currentPage = 1;
      this.scrollMedicineToTop();
      this.getMedicine();
    },

    inputSearchOnKeyUp() {
      debouncer(() => {
        this.currentPage = 1;
        this.getMedicine();
      }, 500);
    },

    medicineOnScroll(e) {
      let target = e.target;
      if (
        target.scrollTop + target.clientHeight >= target.scrollHeight - 80 &&
        !this.isLoadingMore &&
        this.medicines.length < this.totalRow
      ) {
        this.currentPage++;
        this.getMedicine(true);
      }
    },

    btnQtyOnClick(item, index) {
      let items = this.form.items,
        found = items[index],
        quantity = found.quantity;

      this.modalQuantity.item = found;
      this.modalQuantity.index = index;
      this.modalQuantity.quantity = quantity;
      this.modalQuantity.old_subtotal = found.amount * found.quantity;
      this.modalQuantity.old_quantity = found.quantity;
      this.modalQuantity.stock = found.stock;

      this.$bvModal.show("modal-quantity");
    },

    handleQtyModal() {
      const quantity = Number(this.modalQuantity.quantity);
      if (!Number.isInteger(quantity) || quantity < 1) {
        Swal.fire("Jumlah tidak valid", "Masukkan jumlah minimal 1.", "warning");
        return;
      }
      if (quantity > Number(this.modalQuantity.stock)) {
        Swal.fire({
          title: "Pemberitahuan",
          text: "Jumlah Melebihi Ketersediaan Stock!",
          icon: "warning",
          showConfirmButton: false,
          timer: 1800,
          timerProgressBar: true,
        });
        return;
      }
      this.form.items[this.modalQuantity.index].quantity = quantity;
      this.form.items[this.modalQuantity.index].subtotal =
        Number(this.form.items[this.modalQuantity.index].amount) * quantity;
      this.recalculateTotals();
      this.$bvModal.hide("modal-quantity");
    },

    btnAddQtyOnClick(item, index) {
      let items = this.form.items,
        found = items[index],
        quantity = found.quantity;
      if (quantity >= found.stock) {
        Swal.fire({
          title: "Pemberitahuan",
          text: "Jumlah Melebihi Ketersediaan Stock!",
          icon: "warning",
          showConfirmButton: false,
          timer: 1800,
          timerProgressBar: true,
        });
        return;
      }
      found.quantity += 1;
      found.subtotal = found.amount * found.quantity;
      this.recalculateTotals();
    },

    btnMinQtyOnClick(item, index) {
      let items = this.form.items,
        found = items[index],
        quantity = found.quantity;
      if (quantity == 1) {
        quantity = 0;
        items.splice(index, 1);
      } else {
        found.quantity -= 1;
        found.subtotal = found.amount * found.quantity;
      }
      this.recalculateTotals();
    },

    removeUnavailableItem(index) {
      this.form.itemsUnavailable.splice(index, 1);
    },

    cardMedicineOnClick(item, promoAmount) {
      if (item.stock <= 0) {
        Swal.fire("Peringatan", "Stok Habis", "warning");
        return;
      }
      let exist = false,
        medicineId,
        quantity = 0,
        items = this.form.items;
      items.forEach((element) => {
        if (element.medicine_id == item.id) {
          medicineId = element.medicine_id;
          quantity = element.quantity;
          exist = true;
        }
      });
      if (exist) {
        let found = items.findIndex((x) => x.medicine_id == medicineId);
        if (items[found].quantity >= items[found].stock) {
          Swal.fire({
            title: "Pemberitahuan",
            text: "Jumlah Melebihi Ketersediaan Stock!",
            icon: "warning",
            showConfirmButton: false,
            timer: 1800,
            timerProgressBar: true,
          });
          return;
        }
        items[found].quantity = quantity += 1;
        items[found].subtotal = parseInt(quantity * items[found].amount);
      } else {
        items.push({
          medicine_id: item.id,
          promo_id: item.promo_id,
          medicine_name: item.name,
          quantity: 1,
          amount: item.sales_price,
          promo_amount: promoAmount,
          subtotal: item.sales_price,
          stock: item.stock,
          notes: "",
          promo: item.promo,
          promotion_status: item.promotion_status,
          promotion_reason: item.promotion_reason,
          candidate_promo: item.candidate_promo || null,
        });
      }
      this.recalculateTotals();
    },

    setMedicineItemData(item, promoAmount) {
      if (item.stock <= 0) {
        Swal.fire("Peringatan", `Stok ${item.medicine_name} habis`, "warning");
        return;
      }
      let exist = false,
        medicineId,
        quantity = 0,
        items = this.form.items;
      items.forEach((element) => {
        if (element.medicine_id == item.medicine_id) {
          medicineId = element.medicine_id;
          quantity = element.quantity;
          exist = true;
        }
      });
      if (exist) {
        let found = items.findIndex((x) => x.medicine_id == medicineId);
        if (items[found].quantity >= items[found].stock) {
          Swal.fire({
            title: "Pemberitahuan",
            text: "Jumlah Melebihi Ketersediaan Stock!",
            icon: "warning",
            showConfirmButton: false,
            timer: 1800,
            timerProgressBar: true,
          });
          return;
        }
        items[found].quantity = Math.min(
          Number(items[found].stock),
          Number(items[found].quantity) + Number(item.quantity)
        );
        items[found].subtotal = Number(items[found].quantity) * Number(items[found].amount);
      } else {
        items.push({
          medicine_id: item.medicine_id,
          promo_id: item.promo ? item.promo.id : null,
          medicine_name: item.medicine_name,
          quantity: item.quantity,
          amount: item.amount,
          promo_amount: promoAmount,
          subtotal: item.amount,
          stock: item.stock,
          notes: "",
          promo: item.promo,
          promotion_status: item.promotion_status,
          promotion_reason: item.promotion_reason,
          candidate_promo: item.candidate_promo || null,
        });
      }
      this.recalculateTotals();
    },

    modalCheckoutOnHide() {
      this.error = validation.clearValidationError(this.error);
      this.form.payment_amount = 0;
      this.form.change_amount = 0;
    },

    paymentMethodOnClick(id) {
      this.form.notes = "";
      this.form.payment_method_id = id;
      this.recalculateTotals();
      this.schedulePromotionRefresh();
    },

    async btnCheckoutOnClick() {
      if (!this.cashierShift && !(this.fulfillmentMode==="standard"&&!this.form.pharmacy_fulfillment_order_id)) {
        Swal.fire("Shift belum dibuka", "Buka shift kasir sebelum memproses pembayaran.", "warning");
        return;
      }
      if (this.form.items.length == 0) {
        Swal.fire({
          title: "Peringatan",
          text: "Anda Belum Memilih Obat",
          icon: "warning",
        });
        return;
      }
      if(this.fulfillmentMode==="standard"&&!this.form.pharmacy_fulfillment_order_id){await this.createStandardFulfillment();return;}
      this.form.fulfillment_mode=this.fulfillmentMode;
      if(this.fulfillmentMode==="express"){await this.previewExpress();return;}
      this.$bvModal.show("modal-checkout");
    },

    btnShortCutOnClick(amount) {
      if (amount != 0) {
        this.form.payment_amount = parseInt(amount).toLocaleString("id-ID");
        this.form.change_amount =
          parseInt(this.form.payment_amount.toString().replace(/\D/g, ""), 10) -
          this.form.final_amount;
      } else {
        this.form.payment_amount = parseInt(
          this.form.final_amount
        ).toLocaleString("id-ID");
        this.form.change_amount = 0;
      }
    },

    btnEWalletOnClick(id) {
      this.form.e_wallet_id = id;
    },

    inputCashOnKeyUp() {
      this.form.change_amount =
        parseInt(this.form.payment_amount.toString().replace(/\D/g, ""), 10) -
        this.form.final_amount;
    },

    async confirmCheckout() {
      if (this.isSubmitting) return;
      if (!this.cashierShift) {
        Swal.fire("Shift belum dibuka", "Muat ulang atau buka shift kasir terlebih dahulu.", "warning");
        return;
      }
      if (!this.form.idempotency_key) this.form.idempotency_key = `pharmacy-${Date.now()}-${Math.random().toString(36).slice(2,10)}`;
      this.form.cashier_shift_id = this.cashierShift.id;
      this.form.allergies = this.safetyContext.allergies.split(",").map(value => value.trim()).filter(Boolean);
      this.form.conditions = this.safetyContext.conditions.split(",").map(value => value.trim()).filter(Boolean);
      if (!this.form.allocations || this.form.allocations.length === 0) {
        this.form.allocations = [{
          payment_method_id: this.form.payment_method_id,
          amount: this.form.final_amount,
          reference_number: this.form.edc_struct || "",
        }];
      }
      if (
        parseInt(this.form.payment_amount.toString().replace(/\D/g, ""), 10) <
          this.form.final_amount &&
        this.form.payment_method_id == 1
      ) {
        Swal.fire({
          title: "Peringatan",
          text: "Uang Tidak Cukup",
          icon: "warning",
        });
        return;
      } else {
        this.isSubmitting = true;
        let response;
        try {
          response = await module.submit(
          this.form,
          "pharmacy-orders/checkout"
          );
        } catch (error) {
          Swal.fire("Transaksi gagal", "Terjadi gangguan. Silakan coba lagi.", "error");
          return;
        } finally {
          this.isSubmitting = false;
        }
        if (response.state == "error") {
          this.error = validation.setValidationError(
            this.error,
            response.error.errors
          );
        } else {
          let visitCompletionMessage = response.success.message;
          if (
            typeof this.prescriptId != "undefined" &&
            this.prescriptId != null &&
            this.prescriptId != ""
          ) {
            this.prescriptData.redeem_status = 1;

            const dischargeConfirmation = await Swal.fire({
              title: "Obat sudah diterima pasien?",
              text: "Konfirmasikan setelah obat diserahkan, aturan pakai dijelaskan, dan pasien benar-benar meninggalkan klinik.",
              icon: "question",
              showCancelButton: true,
              confirmButtonText: "Ya, pasien sudah pulang",
              cancelButtonText: "Belum, konfirmasi nanti",
              confirmButtonColor: "var(--skin-primary)",
            });

            if (dischargeConfirmation.value) {
              try {
                const completion = await ApiService.put(
                  `prescriptions/${this.prescriptId}/complete-visit`,
                  {}
                );
                visitCompletionMessage = completion.data.message;
              } catch (completionError) {
                visitCompletionMessage = "Obat sudah tercatat diserahkan, tetapi status pasien pulang belum tersimpan. Konfirmasikan dari Daftar Resep Obat.";
              }
            } else {
              visitCompletionMessage = "Obat sudah tercatat diserahkan. Status pasien pulang dapat dikonfirmasi dari Daftar Resep Obat.";
            }
          }

          Swal.fire({
            title: response.success.title,
            text: visitCompletionMessage,
            icon: "success",
          }).then((result) => {
            if (result.value) {
              this.$router.push(
                `/pharmacy/sales/detail/${response.success.order.order_id}`
              );
            }
          });
          this.form.idempotency_key = "";
        }
      }
    },
  },

  mounted() {
    // BreadCrumb
    this.$store.dispatch(SET_BREADCRUMB, [
      { title: "Apotek", route: "" },
      { title: "Tambah Penjualan" },
    ]);
    // get data
    this.getMedicineCategories();
    this.getMedicine();
    this.loadCashierShift();
    this.loadWarehouses();
    this.loadReleasedCompounds();
    this.loadReadyFulfillments();

    // set data form prescriptions
    if (
      typeof window.data != "undefined" &&
      window.data != null &&
      typeof window.data === "object" &&
      Array.isArray(window.data.available)
    ) {
      const arr = window.data;

      // set form prescription_id
      this.form.prescription_id = window.id;

      // push item into form selected item
      arr.available.forEach((el) => {
        this.setMedicineItemData(el, getPromoAmount(el.promo, el.amount));
      });

      this.form.itemsUnavailable = (arr.unavailable || []).map((item) => ({
        ...item,
        promo_amount: getPromoAmount(item.promo, item.amount),
      }));
      if (this.form.itemsUnavailable.length > 0) {
        const medicineUnavailableText = this.form.itemsUnavailable
          .map((item) => item.medicine_name)
          .join(", ");
        Swal.fire(
          "Stok tidak mencukupi",
          `${medicineUnavailableText} tidak dimasukkan ke pembayaran.`,
          "warning"
        );
      }

      // set patient data
      this.form.patient_id = arr.patient_id;
      this.form.patient_name = arr.patient_name
        ? arr.patient_name
        : "Pilih Pasien";
      this.display.patient_name = arr.patient_name
        ? arr.patient_name
        : "Pilih Pasien";

      // set doctor
      this.form.doctor_id = arr.doctor_id;
      this.form.doctor_name = arr.doctor_name
        ? arr.doctor_name
        : "Pilih Dokter";
      this.display.doctor_name = arr.doctor_name
        ? arr.doctor_name
        : "Pilih Dokter";

      // set prescription id
      if (window.id) this.getDataPrescription(window.id);

      // reset global data
      window.data = [];
      this.schedulePromotionRefresh();
    }
  },
};
</script>

<style scoped>
/* width */
.nav-category::-webkit-scrollbar {
  width: 3px !important;
  height: 5px !important;
}

/* Track */
.custom-scroller::-webkit-scrollbar-track {
  box-shadow: inset 0 0 5px rgb(221, 221, 221) !important;
  border-radius: 10px !important;
}

/* Handle */
.custom-scroller::-webkit-scrollbar-thumb {
  background: #0bb7af !important;
  border-radius: 10px !important;
}

/* Handle on hover */
.custom-scroller::-webkit-scrollbar-thumb:hover {
  background: #0bb7af !important;
}

.nav-category {
  display: -webkit-box;
  white-space: nowrap !important;
  overflow-x: auto !important;
  scrollbar-width: none;
}

.custom-scroller {
  display: -webkit-box;
  white-space: nowrap !important;
  overflow-x: auto !important;
  scrollbar-width: none;
}

.modal-trigger {
  height: 54.23px;
  font-size: 13px;
}

.nav-category li {
  display: inline-block !important;
  float: none !important;
}

.btn-quantity {
  min-width: 35px;
}

.pharmacy-promo-badge {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  width: fit-content;
  margin: 2px 0;
  padding: 2px 7px;
  border-radius: 999px;
  color: #0f5132;
  background: #d1e7dd;
  font-size: 10px;
  font-weight: 700;
}

.pharmacy-promo-hint {
  display: block;
  max-width: 260px;
  color: #8a6116;
  line-height: 1.25;
}

/* width */
::-webkit-scrollbar {
  width: 5px;
  height: 5px;
}

/* Track */
::-webkit-scrollbar-track {
  background: #f1f1f1;
}

/* Handle */
::-webkit-scrollbar-thumb {
  background: var(--skin-primary) !important;
}

/* Handle on hover */
</style>

<style lang="scss" src="@/assets/sass/pages/_pharmacy-cashier.scss"></style>
